import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import UpgradeAlertModalActions from 'flux/actions/UpgradeAlertModalActions';
import ModalActions from 'flux/actions/ModalActions';
import Constants from 'shared/constants/UpgradeConstants';
import UIRegions from 'shared/constants/UIRegions';
import { Map } from 'immutable';

/**
 * Upgrade Alert Modal Store
 */

export default Reflux.createStore({
  mixins: [BaseMixin],

  listenables: [UpgradeAlertModalActions],

  init() {
    this._init();
  },

  _init() {
    this.setState(Map());
  },

  onClear() {
    this._init();
  },

  onShowAlert(type) {
    this.setStateAndTrigger(
      Map({
        type,
        title: Constants[`${type}Title`],
        desc: Constants[`${type}Desc`],
        assetLink: Constants[`${type}Asset`],
        learnMoreLink: Constants[`${type}LearnLink`],
        upgradeLink: Constants[`${type}UpgradeLink`],
        classes: `${type}`,
      }),
    );

    ModalActions.show(UIRegions.UpgradeAlert);
  },
});
